import axios from "axios";
import toQueryString from "../common/utils/to-query-string";

const getMine = (query) => axios.get(toQueryString("api/v1/projects/mine?", query));

// const getOne = (id, query) =>
//   axios.get(toQueryString(`/api/v1/projects/${id}?`, query));

const update = (id, payload) =>
  axios.put(`api/v1/projects/${id}`, payload);

const create = (body) => axios.post("api/v1/projects", body);

const deleteProject = (id) => axios.delete(`api/v1/projects/${id}`);

const cancelProjectProvision = (projectId) =>
  axios.put(`api/v1/projects/${projectId}/cancel-provision`);

const ApiProjects = {
  getMine,
  // getOne,
  update,
  create,
  deleteProject,
  cancelProjectProvision
};

export default ApiProjects;
